/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protein_Supplement_SometimesInputs */

const en_us2_protein_supplement_sometimes = /** @type {(inputs: Protein_Supplement_SometimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sometimes`)
};

const pt_br2_protein_supplement_sometimes = /** @type {(inputs: Protein_Supplement_SometimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Às vezes`)
};

const es_419_protein_supplement_sometimes = /** @type {(inputs: Protein_Supplement_SometimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A veces`)
};

const pt_pt2_protein_supplement_sometimes = /** @type {(inputs: Protein_Supplement_SometimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Às vezes`)
};

const fr_fr2_protein_supplement_sometimes = /** @type {(inputs: Protein_Supplement_SometimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parfois`)
};

const de_de2_protein_supplement_sometimes = /** @type {(inputs: Protein_Supplement_SometimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manchmal`)
};

const it_it2_protein_supplement_sometimes = /** @type {(inputs: Protein_Supplement_SometimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A volte`)
};

/**
* | output |
* | --- |
* | "Sometimes" |
*
* @param {Protein_Supplement_SometimesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protein_supplement_sometimes = /** @type {((inputs?: Protein_Supplement_SometimesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protein_Supplement_SometimesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protein_supplement_sometimes(inputs)
	if (locale === "es-419") return es_419_protein_supplement_sometimes(inputs)
	if (locale === "pt-PT") return pt_pt2_protein_supplement_sometimes(inputs)
	if (locale === "fr-FR") return fr_fr2_protein_supplement_sometimes(inputs)
	if (locale === "de-DE") return de_de2_protein_supplement_sometimes(inputs)
	if (locale === "it-IT") return it_it2_protein_supplement_sometimes(inputs)
	return en_us2_protein_supplement_sometimes(inputs)
});
export { protein_supplement_sometimes as "protein_supplement.sometimes" }